'use client'
import {
  useTableStyles
} from "./chunk-GEJVU65N.mjs";

// src/thead.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Thead = forwardRef((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ jsx(chakra.thead, { ...props, ref, __css: styles.thead });
});

export {
  Thead
};
//# sourceMappingURL=chunk-DRZNIHMG.mjs.map